interface ConstructorWrapperInstance {
  instance: ConstructorInstance
  updateSearch: () => void
}

export const provideInjectKey: InjectionKey<ConstructorWrapperInstance> = Symbol()
